import { render, staticRenderFns } from "./TelegramKeySettings.vue?vue&type=template&id=452b7bc2"
import script from "./TelegramKeySettings.vue?vue&type=script&lang=js"
export * from "./TelegramKeySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports